import { TDeleteBannerParams } from 'core/model/interfaces/banners';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { getErrorMessageFromAction } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../constants';
import { IBannersState } from '../types';

export const deleteBanner = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/deleteBanner`,
  async (params: TDeleteBannerParams, { rejectWithValue }) => {
    try {
      await apiService.banners.deleteBanner(params);

      notificationService.global.success('Banner eliminado correctamente.');
    } catch (error) {
      notificationService.global.error('Error al eliminar el banner.');

      return rejectWithValue(error);
    }
  },
);

export const deleteBannerReducer: TSliceExtraReducer<IBannersState> = builder =>
  builder
    .addCase(deleteBanner.pending, state => {
      state.modal.loading = true;
      state.modal.success = false;
    })
    .addCase(deleteBanner.rejected, (state, action) => {
      state.modal.loading = false;
      state.modal.success = false;

      state.modal.error = getErrorMessageFromAction(action.payload, 'Error al eliminar el banner.');
    })
    .addCase(deleteBanner.fulfilled, state => {
      state.modal.loading = false;
      state.modal.success = true;
    });
